<template>
	<div class="book-c-review">
		<div class="bookcr-box">
			<div class="bcr-head">
				<label>订单信息确认</label>
			</div>
			<div class="bcr-content">
				<div class="bcrc-text">
					<label>景点名称：</label>
					<span>{{bookInfo.ScenicName}}</span>
				</div>
				<div class="bcrc-text">
					<label>门票名称：</label>
					<span>{{bookInfo.TicketName}}</span>
				</div>
				<div class="bcrc-text">
					<label>游玩日期：</label> 
					<span class="active">{{info.mySelect.PriceDate|dateToYMDline}}</span>
				</div>
				<div class="bcrc-text"> 
					<label>门票数量：</label>
					<span>{{info.stock}}  张</span>
				</div>
				<div class="bcrc-text">
					<label>订单总额：</label>
					<span>{{Currency}} {{info.mySelect.Price*info.stock}} </span>
				</div>
				<div class="bcrc-text">
					<label>游客姓名：</label> 
					<div class="bcrc-guest">
						<span >{{info.PickUpName}}</span>
						<span v-for="(item,index) in info.Guests" v-if="info.Guests&&info.Guests.length>0">{{item.LastName}} {{item.FirstName}}</span>
					</div>
				</div>
		
				<div class="bcrc-text">
					<label>取消规则：</label>
					<span>{{bookInfo.RegressionRule||'无'}}</span>
				</div>
			</div>

			<div class="bcr-commit">
				<span class="bcr-ok" @click="ok">确认提交</span>
				<span class="bcr-cancel" @click="cancel">返回</span>
			</div>
		</div>
	</div>
	
</template>
<script>
	export default{
		props:{
			info: {
                type: Object,
                default: function(){
                	return {}
                }
            }
		},
		data(){
			return{
				bookInfo:this.dao.get('ticketBookInfo'),
				Currency: this.dao.get('userInfo').Currency,
			}
		},
		methods:{
			ok(){
				this.$emit('ok')
			},
			cancel(){
				this.$emit('cancel')
			},

		}
	}
</script>


// WEBPACK FOOTER //
// src/components/ticket/book/bookReview.vue